import { Theme } from '@mui/material';
/**
 * Styling for ccf-full-view-settings
 * @returns ccf-full-view-settings CSS properties as a JSON object
 * @example ccfFullViewSettingsStyles(theme, props)
 */
const ccfAppSettingsStyles = (theme: Theme) => {
  const styles = {
    settingsContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      position: 'relative',
      height: '100%',
      width: 'auto',
      padding: '15px 10px',
      borderRadius: '6px',
    },
    menuTab: {
      padding: '10px 0px 10px 0px',
    },
    select: {
      width: '300px',
      [theme.breakpoints.down('xl')]: {
        width: '265px',
      },
    },
    FullViewSettingsCard: {
      width: '100%',
      height: '100%',
      background: `${theme.palette.background.light} 0% 0% no-repeat padding-box`,
      boxShadow: `0px 1px 3px ${theme.palette.boxshadow?.main}`,
      border: `1px solid ${theme.palette.border?.main}`,
      [theme.breakpoints.up('xl')]: {
        borderRadius: '6px',
      },
      opacity: 1,
      transition: 'all 0.5s ease',
      display: 'flex',
      flexDirection: 'column',
      '& .MuiOutlinedInput-input': {
        ...theme.typography.h4,
        [theme.breakpoints.down('xl')]: {
          ...theme.typography.h6,
          fontSize: '1rem',
        },
      },
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '5px',
      },
      '.MuiTabs-root': {
        '.MuiButtonBase-root': {
          fontWeight: 700,
        },
        '.Mui-selected': {
          color: theme.palette.primary.dark,
        },
      },
    },
    settingsHeader: {
      background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      height: '33px',
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '5px',
      },
    },
    container: {
      overflowY: 'auto',
      height: '100%',
      backgroundColor: `${theme.palette.background.paper}`,
    },
  };
  return styles;
};

export default ccfAppSettingsStyles;
